import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-navy-900 font-sans text-gray-100 selection:bg-gold-500/30 selection:text-gold-400" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <FailedSolutionsSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <WhoIsItForSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}